<template>
	<div class="add-app-version">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="
				appVersion.id ? $t('addAppVersion.edit') : $t('addAppVersion.add')
			"
			:visible.sync="dialogAppVersion"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="appVersion"
					label-width="80px"
					:model="appVersion">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.appType')"
								prop="appType"
								:error="error.appType">
								<el-select
									v-model="appVersion.appType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									:placeholder="$t('addAppVersion.pAppType')">
									<el-option
										v-for="item in appTypeList"
										:key="item.id"
										:label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.appName')"
								prop="appName"
								:error="error.appName">
								<el-input
									v-model="appVersion.appName"
									:placeholder="$t('addAppVersion.pAppName')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.appVersionBefore')"
								prop="appVersionBefore"
								:error="error.appVersionBefore">
								<el-input
									v-model="appVersion.appVersionBefore"
									:placeholder="$t('addAppVersion.pAppVersionBefore')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.appVersion')"
								prop="appVersion"
								:error="error.appVersion">
								<el-input
									v-model="appVersion.appVersion"
									:placeholder="$t('addAppVersion.pAppVersion')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.appImage')"
								prop="appImage"
								:error="error.appImage">
								<el-upload
									class="upload-icon"
									:action="iconUrl"
									:headers="headers"
									:on-success="iconSuccess"
									:before-upload="iconUpload"
									:on-remove="iconRemove"
									:on-error="iconError"
									:file-list="iconFileList"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								:label="$t('addAppVersion.downUrl')"
								prop="downUrl"
								:error="error.downUrl">
								<el-upload
									class="upload-app"
									:action="appUrl"
									:headers="headers"
									:on-success="appSuccess"
									:before-upload="appUpload"
									:on-remove="appRemove"
									:on-error="appError"
									:limit="1"
									:file-list="appFileList">
									<el-button slot="trigger" size="small" type="primary">{{
										$t("addAppVersion.trigger")
									}}</el-button>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addAppVersion.notes')">
								<el-input
									type="textarea"
									:rows="4"
									v-model="appVersion.notes"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('appVersion')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import config from "@/http/config";
export default {
	name: "AddAppVersion",
	props: {
		appVersion: Object,
		dialogAppVersion: Boolean,
		appTypeList: Array,
	},
	data() {
		return {
			labelPosition: "top",
			loadingForm: false,
			rules: {
				appType: [
					{
						required: true,
						message: this.$t("addAppVersion.pAppType"),
						trigger: "blur",
					},
				],
				appVersion: [
					{
						required: true,
						message: this.$t("addAppVersion.pAppVersion"),
						trigger: "blur",
					},
				],
				appName: [
					{
						required: true,
						message: this.$t("addAppVersion.pAppName"),
						trigger: "blur",
					},
				],
				appVersionBefore: [
					{
						required: true,
						message: this.$t("addAppVersion.pAppVersionBefore"),
						trigger: "blur",
					},
				],
				appImage: [
					{
						required: true,
						message: this.$t("addAppVersion.rAppImage"),
						trigger: "blur",
					},
				],
				downUrl: [
					{
						required: true,
						message: this.$t("addAppVersion.rDownUrl"),
						trigger: "blur",
					},
				],
			},
			error: {
				appType: "",
				appVersion: "",
				appName: "",
				appVersionBefore: "",
				appImage: "",
				downUrl: "",
			},
			clear: false,
			headers: {
				token: this.$cookies.get("token"),
			},
			iconUrl: config.baseUrl + this.$url.Upload.appIcon,
			appUrl: config.baseUrl + this.$url.Upload.app,
			iconFileList: [],
			appFileList: [],
		};
	},
	methods: {
		cancel(state) {
			this.$emit("cancel", false, state);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.AppVersion.insert;
					let method = this.$method.post;
					if (this.appVersion.id) {
						url = this.$url.AppVersion.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.appVersion)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.cancel(this.appVersion.id ? "update" : "save");
							} else {
								this.$toolUtil.msg(res, this.error);
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
		closeDialog() {
			this.clearValidate("appVersion");
			if (!this.addOrEdit) {
				this.$toolUtil.clearForm(this.appVersion);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.appVersion);
				}
			}
			this.cancel("");
			this.iconFileList = [];
			this.appFileList = [];
		},
		openDialog() {
			if (this.appVersion.id) {
				if (this.iconFileList.length <= 0 && this.appVersion.appImage) {
					this.iconFileList.push({ url: this.appVersion.appImage });
					this.hideUpload();
				}
				if (this.appFileList.length <= 0 && this.appVersion.downUrl) {
					this.appFileList.push({
						name: this.appVersion.appName,
						url: this.appVersion.downUrl,
					});
				}
			} else {
				this.showUpload(true);
			}
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		iconSuccess(res) {
			if (res.code === 0) {
				this.appVersion.appImage = res.data;
			}
		},
		iconUpload() {
			this.hideUpload();
		},
		iconRemove() {
			this.showUpload();
		},
		iconError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("addAppVersion.error"));
			this.showUpload();
		},
		appSuccess(res) {
			if (res.code === 0) {
				this.appVersion.downUrl = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		appUpload() {},
		appRemove() {},
		appError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("addAppVersion.error"));
		},
		hideUpload() {
			this.$nextTick(() => {
				let card = window.document.querySelector(".el-upload--picture-card");
				card.style.display = "none";
			});
		},
		showUpload(boo) {
			if (boo) {
				this.$nextTick(() => {
					let card = window.document.querySelector(".el-upload--picture-card");
					card.style.display = "block";
				});
			} else {
				setTimeout(() => {
					let card = window.document.querySelector(".el-upload--picture-card");
					card.style.display = "block";
				}, 1000);
			}
		},
	},
};
</script>

<style lang="scss">
.upload-icon {
	.el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 88px;
	}
	.el-upload-list__item {
		width: 80px !important;
		height: 80px !important;
		margin-bottom: 0 !important;
	}
	.el-form-item__content {
		line-height: 0;
	}
}
.upload-app .el-upload__tip {
	line-height: 16px;
}
</style>
